/**
 * Espelha ScheduleRecalculationService::calculateParentCompletion — média ponderada
 * por estimated_time_hours; fallback para total_value; senão média simples.
 */
export type ParentCompletionChild = {
  completion_percentage: number;
  estimated_time_hours?: number | null;
  total_value?: number | null;
};

export function calculateParentCompletion(
  children: ParentCompletionChild[],
): number {
  if (!children.length) {
    return 0;
  }

  let weights = children.map(
    (child) => Number(child.estimated_time_hours) || 0,
  );

  if (weights.reduce((sum, weight) => sum + weight, 0) <= 0) {
    weights = children.map((child) => Number(child.total_value) || 0);
  }

  const weightSum = weights.reduce((sum, weight) => sum + weight, 0);

  if (weightSum <= 0) {
    const avg =
      children.reduce(
        (sum, child) => sum + (Number(child.completion_percentage) || 0),
        0,
      ) / children.length;

    return Math.round(avg * 100) / 100;
  }

  let weighted = 0;
  children.forEach((child, index) => {
    weighted +=
      (Number(child.completion_percentage) || 0) * (weights[index] || 0);
  });

  return Math.round((weighted / weightSum) * 100) / 100;
}
